<script setup lang="ts">
  // Bot trap: off-screen rather than display:none (naive bots skip hidden inputs), and unreachable by
  // keyboard / screen readers so humans never fill it. Raw <input> on purpose — an HL input would be styled/visible.
  const model = defineModel<string>({ default: '' })
</script>

<template>
  <div class="honeypot-field" aria-hidden="true">
    <input v-model="model" type="text" name="website" tabindex="-1" autocomplete="off" />
  </div>
</template>

<style scoped>
  .honeypot-field {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
</style>
